import cn from "classnames";
import { paths } from "helpers/paths";
import { useLocalStorage } from "hooks/useLocalStorage";
import React, { useState } from "react";
import { cloneBid } from "sources/books/bids";

export default function CloneBid(props) {
    const [clearDates, setClearDates] = useLocalStorage("clear-dates-on-clone-bid", true);
    const [loading, setLoading] = useState(false);
    const createCopy = () => {
        props.setLoading(true);
        setLoading(true);
        cloneBid({ id: props.bidId })
            .then(({ id }) => {
                if (id) {
                    props.history.push(`${paths.bidEdit(id)}${clearDates ? "?isCopy=true" : ""}`);
                } else {
                    props.setLoading(false);
                    setLoading(false);
                }
            })
            .catch(() => {
                props.setLoading(false);
                setLoading(false);
            });
    };
    return (
        <div className={loading ? "loading" : ""}>
            <div className="col-form-label-sm d-inline-block mb-3" onClick={() => setClearDates(!clearDates)}>
                <div className={cn("checkbox d-inline-block", { "checkbox--checked": clearDates })} />
                &nbsp;
                <div className="d-inline-block checkbox__text">Сбросить даты точек загрузки/выгрузки</div>
            </div>
            <div className="btn btn-sm btn-brand btn-block" onClick={createCopy}>
                Создать копию заявки
            </div>
        </div>
    );
}
